import ErrorStatus from '$shared/constants/ErrorStatus';
import Label from '$shared/constants/Label';
import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { formatString } from '$shared/helpers/utils';
import { ErrorMessage } from '$shared/models/ErrorMessage';
import type { ErrorStatusMapping } from '.';

class FileError {
  public getList(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        formatString(UIErrorMessage.FailedToGetList, Label.File),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        formatString(UIErrorMessage.PermissionMissingToGetInfo, 'file metadata'),
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        UIErrorMessage.TryingToGetFileFromUnknownFolder,
        true
      )
    };
  }

  public delete(): ErrorStatusMapping {
    return {
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.TryingToDeleteUnknownFile, true)
    };
  }

  public upload(): ErrorStatusMapping {
    return {
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToUploadFile,
        true
      ),
      [ErrorStatus.Conflict]: ErrorMessage.create(UIErrorMessage.FileAlreadyExistInFolder, true)
    };
  }

  public overwriteFile(): ErrorStatusMapping {
    return {
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToUploadFile,
        true
      )
    };
  }

  public getMetadata(): ErrorStatusMapping {
    return {
      [ErrorStatus.NotModified]: ErrorMessage.create(''),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToGetFileMetadata,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.TryingToGetUnknownFile, true)
    };
  }

  public download(): ErrorStatusMapping {
    return {
      [ErrorStatus.NotModified]: ErrorMessage.create(''),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        UIErrorMessage.MissingPermissionToDownloadFile,
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(UIErrorMessage.TryingToDownloadUnknownFile, true)
    };
  }
}

export const fileError = new FileError();
